<div class="acs-theme-selector">
  <div class="theme-section">
    <h4>Theme Selection</h4>
    <div class="theme-options">
      <div *ngFor="let theme of availableThemes" class="theme-option">
        <label>
          <input 
            type="radio" 
            name="theme" 
            [value]="theme.value"
            [checked]="currentTheme === theme.value"
            (change)="onThemeChange(theme.value)">
          <span class="theme-label">
            <strong>{{ theme.label }}</strong>
            <small>{{ theme.description }}</small>
          </span>
        </label>
      </div>
    </div>
  </div>

  <div class="spacing-section">
    <h4>Spacing Preference</h4>
    <div class="spacing-options">
      <select 
        [(ngModel)]="currentSpacing" 
        (change)="onSpacingChange(currentSpacing)"
        class="spacing-select">
        <option *ngFor="let spacing of availableSpacing" [value]="spacing.value">
          {{ spacing.label }} - {{ spacing.description }}
        </option>
      </select>
    </div>
  </div>

  <div class="custom-colors-section" *ngIf="currentTheme === 'default'">
    <h4>Custom Chapter Colors (Optional)</h4>
    <div class="color-inputs">
      <div class="color-input">
        <label for="primary-color">Primary Color:</label>
        <input 
          id="primary-color"
          type="color" 
          [(ngModel)]="customColors.primary"
          (change)="onCustomColorChange()"
          placeholder="Primary Color">
        <input 
          type="text" 
          [(ngModel)]="customColors.primary"
          (blur)="onCustomColorChange()"
          placeholder="#0F2144"
          class="color-text">
      </div>
      
      <div class="color-input">
        <label for="secondary-color">Secondary Color:</label>
        <input 
          id="secondary-color"
          type="color" 
          [(ngModel)]="customColors.secondary"
          (change)="onCustomColorChange()"
          placeholder="Secondary Color">
        <input 
          type="text" 
          [(ngModel)]="customColors.secondary"
          (blur)="onCustomColorChange()"
          placeholder="#8AA3B0"
          class="color-text">
      </div>
      
      <div class="color-input">
        <label for="accent-color">Accent Color:</label>
        <input 
          id="accent-color"
          type="color" 
          [(ngModel)]="customColors.accent"
          (change)="onCustomColorChange()"
          placeholder="Accent Color">
        <input 
          type="text" 
          [(ngModel)]="customColors.accent"
          (blur)="onCustomColorChange()"
          placeholder="#0045D0"
          class="color-text">
      </div>
    </div>
  </div>

  <div class="theme-actions">
    <acs-button variant="secondary" (clicked)="toggleDarkMode()">
      {{ currentTheme === 'dark' ? 'Light Mode' : 'Dark Mode' }}
    </acs-button>
    <acs-button variant="text" (clicked)="resetTheme()">
      Reset to Default
    </acs-button>
  </div>
</div>
